import React from 'react'
import SectionWrapper from '@components/ui/wrappers/SectionWrapper'
import styled from 'styled-components'
import PageHeaderFlexible from '@components/ui/typography/PageHeaderFlexible'

const GeneratorHeaderSection = ({ titleIcon, title, description }) => {
  return (
    <SectionWrapper>
      <Wrapper id="ai-tools-form">
        <PageHeaderFlexible
          maxWidthTitle="1920px"
          maxWidthDescription="800px"
          titleIcon={titleIcon}
          title={title}
          description={description}
        />
      </Wrapper>
    </SectionWrapper>
  )
}

export default GeneratorHeaderSection

const Wrapper = styled.div``
